//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { exportFile } from 'quasar'
import { csvGenerator } from "@/utils/csvGenerator.js";

// function wrapCsvValue(val, formatFn) {
//   let formatted = formatFn !== void 0
//     ? formatFn(val)
//     : val

//   formatted = formatted === void 0 || formatted === null
//     ? ''
//     : String(formatted)

//   formatted = formatted.split('"').join('""')
//   return `"${formatted}"`
// }

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    // this.organizeData();
  },
  data() {
    return {
      data: [],
      columns: [
        { name: 'fields', label: 'Campo', field: (row) => this.findFieldNameById(this.findColumnIdByLetter(row.column)), align: 'left' },
        { name: 'column', label: 'Coluna', field: (row) => row.column, align: 'left' },
        { name: 'type', label: 'Correspondência', field: (row) => this.typeTranslator(row.type), align: 'left' },
        { name: 'values', label: 'Valores', field: (row) => this.removePercent(row), align: 'left' }
      ],

    }
  },
  methods: {
    organizeData() {
      let organized = {};
      this.data = [];
      if (this.object.filtering_rules === null) {
        return;
      }

      this.object.filtering_rules.excluding.forEach(item => {
        //Ver pd Antigo
        if (item.operation == "like") {
          if (!organized[item.field]) {
            organized[item.field] = {};
          }
          if (!organized[item.field]["like"]) {
            organized[item.field]["like"] = [];
          }
          organized[item.field]["like"].push(item.arguments[0]);

        } else {
          item.arguments.forEach(arg => {
            if (!organized[arg.field]["and"]) {
              organized[arg.field]["and"] = [];
            }
            if (!organized[arg.field]["and"].includes(arg.arguments[0])) {
              organized[arg.field]["and"].push(arg.arguments[0]);
            }
          });

        }
      });

      let idCounter = 1;

      for (const key in organized) {
        for (const type in organized[key]) {
          this.data.push({
            id: idCounter++,
            type: type,
            values: organized[key][type].join(', '),
            column: key
          });
        }
      }

    },
    typeTranslator(type) {
      if (type == "like") {
        return "Igual a um dos valores -> ";
      } else if (type == "and") {
        return "Junção de";
      } else {
        return type;
      }
    },
    removePercent(row) {
      if (row.type == "and") {
        return row.values.replace(/%/g, '').replace(',', '+');
      } else {
        return row.values.replace(/%/g, ' ');
      }

    },
    findColumnIdByLetter(letter) {
      return this.object.field_mappings.find(item => item.column === letter).field_id;
    },
    findFieldNameById(id) {
      if (this.fields.length === 0) {
        return undefined;
      }
      return this.fields.find(item => item.id === id).name;
    },
    exportTable() {
      let content = [['Campo', 'Coluna', 'Valor']]
      for (var line of this.data) {
        const field_name = this.findFieldNameById(this.findColumnIdByLetter(line.column));
        const excludedValues = line.values.replaceAll('%', '').split(', ');
        const exclusions = excludedValues.map(e => [field_name, line.column, e]);
        content = content.concat(exclusions);
      }

      let file_name = ''
      if (this.object.name === undefined) {
        file_name = "exclusoes.csv";
      } else {
        file_name = this.object.name.split(' ').join('_').toLowerCase() + "_exclusoes.csv";
      }
      csvGenerator.toCSV(file_name, content);
    }
  },
  watch: {
    object: {
      handler: function () {
        this.organizeData();
      },
      deep: true,
      immediate: true
    }
  }

}
